export enum ChainId {
  MAINNET = 56,
  TESTNET = 97
}